<script setup>
import Footer from "@/layouts/components/Footer.vue";
import Tips from "@/views/Tips.vue";
import Swal from "sweetalert2";

import { programs, notificationAdd } from "@/services/ApiUrlService";
import { toast } from "vue3-toastify";
import { linkProgram } from "@/services/ApiUrlService";
import { headers } from "@/utils/headers";

definePage({
  meta: {
    requiresAuth: true,
  },
});

const { handleApiRequest } = useApiHandler();

const listPrograms = ref([]);
const searchQueryLocal = useDebouncedRef("", 300);
const page = ref(1);
const loading = ref(false);
const isAddSchoolDialogVisible = ref(false);

const filteredPrograms = computed(() => {
  if (!searchQueryLocal.value.trim()) return listPrograms.value;
  return listPrograms.value.filter((program) =>
    program.name.toLowerCase().includes(searchQueryLocal.value.toLowerCase())
  );
});

const listProgram = async () => {
  try {
    loading.value = true;
    const { data, response } = await useApi(`${programs}?limit=999`);
    if (!response.value?.ok) {
      toast.error($gettext("Something went wrong"));
      return;
    }

    listPrograms.value = (data.value?.list ?? []).map((item) => {
      const registered = item?.campaign?.studentRegisteredTotal;
      const surveyed = item?.campaign?.studentSurveyedTotal;

      if (item.campaign) {
        item.campaign.rate =
          surveyed && registered != null ? registered / surveyed : null;
      }
      return item;
    });
  } catch (error) {
    toast.error($gettext("Something went wrong"));
  } finally {
    loading.value = false;
  }
};

const onCancel = () => {
  isAddSchoolDialogVisible.value = false;
};

provide("listProgram", listProgram);

onMounted(() => {
  listProgram();
});
</script>

<template>
  <div class="px-6">
    <ListHeadBox
      class="bg-white"
      :title="$gettext('My forms')"
      :toggleVerticalOverlayNavActive="$attrs.toggleVerticalOverlayNavActive"
    />
  </div>

  <!-- Tips -->
  <Tips />

  <!-- Table  -->
  <TableDragscroll
    :headers="headers"
    :items="filteredPrograms"
    @update:modelValue="handleClick($event)"
  />
  <VCard style="margin: 16px 16px 65px 16px">
    <ContactWithUs />
  </VCard>
  <Footer />
  <Waiting :show="loading" />
</template>

<style lang="scss" scoped></style>
